import { styled } from "@mui/system";
import { Grid, InputLabel, TextField, Typography } from "@mui/material";
import { colors } from "../../../../theme/colors";

import { StyledTextInput } from "./styled";

export const BITextFieldForm = ({
  input: { name, ...restInput },
  meta,
  label,
  required,
  children,
  maxLength,
  minLength,
  ...rest
}) => {
  return (
    <Grid container>
      <Grid item xs={12}>
        <InputLabel
          shrink={false}
          htmlFor={name}
          required={required}
          error={meta.error && meta.touched}
          sx={{
            borderRadius: "6px",
            color: colors.primary,
            fontWeight: 700,
            "&.Mui-focused": {
              color: colors.secondary,
            },
            "& .MuiInputLabel-asterisk": {
              color: "red",
              "&.Mui-focused": {
                color: colors.secondary,
              },
            },
          }}
        >
          {label}
        </InputLabel>

        <StyledTextInput
          {...rest}
          fullWidth
          InputLabelProps={{
            shrink: true,
          }}
          name={name}
          helperText={meta.touched ? meta.error : undefined}
          error={meta.error && meta.touched}
          inputProps={{ ...restInput, maxLength, minLength }}
          required={required}
        >
          {children}
        </StyledTextInput>
      </Grid>
    </Grid>
  );
};

export default BITextFieldForm;
